import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Button,
  Form,
  Modal,
  Col,
  Card,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import axiosInstance from '../../../../hooks/axiosInstance';
import Pusher from 'pusher-js';
import { Oval } from 'react-loader-spinner';


export default function ViewOrderPayment({
  showView,
  closeModal,
  refreshPage,
  order,
}) {
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userTypeId, setUserTypeId] = useState(null);
  const [bankOptions, setBankOptions] = useState([]); // State to hold bank options
  const [selectedBanks, setSelectedBanks] = useState({}); // Store selected banks by order code
  const [statuses, setStatuses] = useState({}); // Store selected statuses by order ID

  const [paymentDetails, setPaymentDetails] = useState({}); // Store amount_paid and date_of_payment by order index

  const handlePaymentDetailChange = (index, field, value) => {
    if (field === "amount_paid") {
      setPaymentDetails((prevDetails) => ({
        ...prevDetails,
        [index]: {
          ...prevDetails[index],
          [field]: value.replace(/,/g, ""),
        },
      }));
    } else {
      setPaymentDetails((prevDetails) => ({
        ...prevDetails,

        [index]: {
          ...prevDetails[index],
          [field]: value,
        },
      }));
    }
  };


  const handleClose = () => {
    closeModal();
  };

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserTypeId(userData.user.user_type_id);
    } else {
      console.log("No user data found");
    }
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      if (order) {
        try {
          const response = await axiosInstance.get("/user/order/get_order_no_paginate", {
            params: {
              order_code: order.order_code, // Fetch orders with the same order_code
            },
          });

          setOrderList(response.data.data.orders);

          // Initialize statuses for the fetched orders
          const initialStatuses = response.data.data.orders.reduce((acc, orderInfo) => {
            acc[orderInfo.order_code] = ''; // Use order_code instead of order_id
            return acc;
          }, {});
          setStatuses(initialStatuses);
        } catch (error) {
          console.error("Error fetching orders:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchOrders();
  }, [order]);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await axiosInstance.get("/user/bank_account/get_account"); // Replace with your actual endpoint to fetch banks
        setBankOptions(response.data.data.accounts || []);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };

    fetchBanks();
  }, []);

  const handleBankChange = (index, event) => {
    const selectedBank = event.target.value;
    setSelectedBanks((prevBanks) => ({
      ...prevBanks,
      [index]: selectedBank, // Use the index as the key
    }));
  };


  const handleStatusChange = (index, newStatus) => {
    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      [index]: newStatus, // Use the index as the key
    }));
  };


  const formatAmount = (amount) => {
    return new Intl.NumberFormat().format(amount);
  };

  // const handleSubmit = async () => {
  //   try {
  //     const ordersArray = orderList.map((orderInfo, index) => ({
  //       order_id: orderInfo.id,
  //       order_code: orderInfo.order_code,
  //       customer_id: orderInfo.customer_id,
  //       payment_type: orderInfo.payment_type,
  //       action: statuses[index], 
  //       bank_account_id: parseInt(selectedBanks[index], 10), 
  //       amount_paid: paymentDetails[index]?.amount_paid,
  //       date_of_payment: paymentDetails[index]?.date_of_payment,
  //     }));

  //     const apiUrl = '/user/payment/approveOrderPayment';
  //     const response = await axiosInstance.post(apiUrl, { orders: ordersArray });

  //     toast.success("Orders processed successfully!");
  //     refreshPage();
  //     handleClose();
  //   } catch (error) {
  //     console.error("Error processing orders:", error);
  //     toast.error("An error occurred while processing the orders.");
  //   }
  // };
  const handleSubmit = async () => {
    try {
      setLoading(true);

      // Filter out orders with incomplete or empty details
      const filteredOrders = orderList
        .map((orderInfo, index) => ({
          order_id: orderInfo.order_id,
          order_code: orderInfo.order_code,
          customer_id: orderInfo.customer_id,
          payment_type: orderInfo.payment_type,
          // action: statuses[index],
          bank_account_id: parseInt(selectedBanks[index], 10),
          amount_paid: paymentDetails[index]?.amount_paid,
          date_of_payment: paymentDetails[index]?.date_of_payment,
        }))
        .filter(order =>
          // order.action &&
          order.bank_account_id &&
          order.amount_paid &&
          order.date_of_payment
        ); // Only include orders with all required fields filled

      if (filteredOrders.length === 0) {
        toast.error("Please complete at least one order form before submitting.");
        return;
      }

      const apiUrl = '/user/payment/approveOrderPayment';
      const response = await axiosInstance.post(apiUrl, { orders: filteredOrders });

      toast.success("Orders processed successfully!");
      window.location.reload(); 
      refreshPage();
      handleClose();
    } catch (error) {
      if (error.response && error.response.data.error) {
        const errorMessage =
          error.response?.data?.error ||
          error.message ||
          "An error occurred";
        toast.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };
  const capitalize = (text) => {
    if (!text) return "";
    return text
      .replace("_", " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const orderDetails = orderList.length > 0 ? (
    orderList.map((orderInfo, index) => (
      <Card className="mb-3" key={index}>
        <Card.Body>
          <strong>Company Name:</strong> {orderInfo.company_name}
          <br />
          <strong>Product Name:</strong> {orderInfo.product_name}
          <br />
          <strong>Total Price:</strong> {orderInfo.total_price}
          <br />
          <strong>Payment Type:</strong> {orderInfo?.payment_type && orderInfo?.payment_type === "cash" ? "Cash/Prepaid" : orderInfo?.payment_type}
          <br />
          <strong>Total Amount Paid:</strong> {orderInfo?.total_amount_paid ? orderInfo.total_amount_paid : 0}
          <br />
          <strong>balance to be Paid:</strong> {orderInfo?.balance_to_be_paid}
          <br />
          <strong>Payment Status:</strong> {orderInfo?.pay_status ? orderInfo?.pay_status : 'pending'}
          <br />

          <strong>Sales-Supervisor Status:</strong>{" "}
          {orderInfo.status === "active" ? (
            <span className="badge bg-success">{orderInfo.status}</span>
          ) : (
            <span className="badge bg-info">{orderInfo.status}</span>
          )}
          <br />

          {["finance", "chain_supply"].map((role, index) => {
            // find the first approved record for this role
            const record = orderInfo.requisitions?.find(
              (req) =>
                req.approved_as === role &&
                req.status !== "pending" &&
                req.approved_by
            );

            return (
              <div key={index}>
                <span>
                  {capitalize(role)}:{" "}
                  {record
                    ? `${record.approved_by.first_name} ${record.approved_by.last_name}`
                    : ""}
                </span>{" "}
                {record ? (
                  <span className="badge bg-success">Approved</span>
                ) : (
                  <span className="badge bg-warning text-dark">Pending</span>
                )}
              </div>
            );
          })}
          <br />

          {orderInfo?.pay_status !== "paid" && (
            <>
              {/* Bank selection for the order */}
              <div className="mt-2">
                <strong>Select Bank:</strong>
                <select
                  className="form-select"
                  value={selectedBanks[index] || ''} // Use the index as the key
                  onChange={(e) => handleBankChange(index, e)} // Pass the index
                >
                  <option value="">Select Bank</option>
                  {bankOptions.map((bank) => (
                    <option key={bank.id} value={bank.id}>{bank.bank}</option>
                  ))}
                </select>
              </div>

              <Col md={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formDate">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Select date"
                    name="date_of_payment"
                    value={paymentDetails[index]?.date_of_payment || ''}
                    onChange={(e) =>
                      handlePaymentDetailChange(index, 'date_of_payment', e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="mb-2">
                <Form.Group className="mb-3" controlId="formAmountToPay">
                  <Form.Label>Amount Paid</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter amount"
                    name="amount_paid"
                    value={formatAmount(paymentDetails[index]?.amount_paid || '')}
                    onChange={(e) =>
                      handlePaymentDetailChange(index, 'amount_paid', e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </>
          )}
        </Card.Body>
      </Card>
    ))
  ) : (
    <p>No order payment details available.</p>
  );

  return (
    <div className="ViewTransaction">
      <ToastContainer />
      <Modal show={showView} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Order Payment Details</Modal.Title>
        </Modal.Header>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "80vh" }}
          >
            <Oval
              height={80}
              width={80}
              color="#FF0200"
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#4fa94d"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </div>
        ) : (
          <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>{orderDetails}</Modal.Body>
        )}

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" disabled={loading} onClick={handleSubmit}>
            {loading ? "Submiting..." : "Submit"}
          </Button>
        </Modal.Footer>

      </Modal>
    </div>
  );
}
